<template>
  <div>
    <!-- 单词基本信息卡片 -->
    <div class="word-card" v-if="wordInfo && wordInfo.word">
      <!-- 主词 -->
      <div class="word-title">{{ wordInfo.word }}</div>

      <!-- 音标（点击发音） -->
      <div class="phonetic-row" @click="playWord(wordInfo.word)">
        <span class="uk-badge">点击发音</span>
        <span class="phonetic-text">/{{ wordInfo.phoneticUk }}/</span>
      </div>

      <!-- 释义 -->
      <div class="info-panel meaning-panel">
        <span class="panel-label">释 义</span>
        <span class="panel-text">{{ wordInfo.meaning }}</span>
      </div>

      <!-- 相似词 -->
      <div class="info-panel similar-panel" v-if="similarWordArr.length">
        <span class="panel-label">🔗 相似词</span>
        <div class="similar-chips">
          <template v-for="(item, i) in similarWordArr">
            <button v-if="!item.isCn" :key="i" class="similar-btn" @click="searchFromTheSimilarity(item.text)">
              {{ item.text }}
            </button>
            <span v-else :key="i" class="similar-cn">{{ item.text }}</span>
          </template>
        </div>
      </div>

      <!-- 短语 -->
      <div class="info-panel phrase-panel" v-if="wordInfo.phrase">
        <span class="panel-label">短 语</span>
        <span class="panel-text">{{ wordInfo.phrase }}</span>
      </div>
    </div>

    <!-- 未查询到单词 -->
    <div class="word-card empty-card" v-else>
      <span class="empty-icon">🌈</span>
      <span class="empty-text">去搜索一个单词，看看它有多美</span>
    </div>

    <!-- 浮动详情（点击相似词后出现，5 秒自动消失） -->
    <div class="float-tip" v-if="floatingData" @click="clearFloating">
      <div class="float-word">{{ floatingData.word }}</div>
      <div class="float-meaning">{{ floatingData.meaning }}</div>
      <div class="float-compare" v-if="floatingData.diffLetters && floatingData.diffLetters.length">
        <span class="float-compare-label">与主词「{{ floatingData.mainWord }}」对比：</span>
        <span
          v-for="(l, i) in floatingData.diffLetters"
          :key="i"
          class="float-letter"
          :class="{ diff: l.diff }"
          :style="{ color: l.color || '' }"
        >{{ l.ch }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../utils/request'
import { splitWords, normalizeNewlines, compareWords } from '../../utils/similar'

export default {
  name: 'SimpleWord',
  data() {
    return {
      wordInfo: {},
      similarWordArr: [],
      floatingData: null
    }
  },
  computed: {
    word() {
      return this.$store.state.word
    }
  },
  watch: {
    word(val) {
      if (val && val.trim()) {
        this.fetchWordInfo(val)
      }
    }
  },
  mounted() {
    const word = (this.$store.state.word || '').trim()
    if (word) {
      this.fetchWordInfo(word)
    }
  },
  methods: {
    // 播放单词发音（有道语音合成）
    playWord(word) {
      if (!word) return
      const audio = new Audio(
        'https://dict.youdao.com/dictvoice?audio=' + encodeURIComponent(word) + '&type=1'
      )
      audio.play()
    },

    // 查询单词基本信息
    async fetchWordInfo(word) {
      this.$store.dispatch('setWord', word)
      try {
        const res = await request.get('/searchforword/wordinfo', { params: { word } })
        if (res.code === 200) {
          const info = res.wordInfo || {}
          if (info.meaning) info.meaning = normalizeNewlines(info.meaning)
          if (info.phrase) {
            info.phrase = normalizeNewlines(info.phrase)
            const w = (info.word || '').trim()
            if (w) {
              info.phrase = info.phrase.replace(
                new RegExp('\\b' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'g'),
                (match, offset) => (offset === 0 ? match : '\n' + match)
              )
            }
          }
          this.wordInfo = info
          this.fetchSimilarWord(word)
        }
      } catch (e) {
        // 拦截器已统一提示
      }
    },

    // 拉取相似词
    async fetchSimilarWord(word) {
      const currentWord = (this.$store.state.word || '').trim() || word
      const key = currentWord
      this._similarKey = key
      try {
        const token = localStorage.getItem('satoken') || ''
        const res = await request.get('/newSimilarity/searchForSimilarity', {
          params: { word: currentWord, code: token }
        })
        if (this._similarKey !== key) return
        if (res.code === 200 && res.NewSimilarity) {
          this.similarWordArr = splitWords(res.NewSimilarity.similarWord)
        } else {
          this.similarWordArr = []
        }
      } catch (e) {
        if (this._similarKey === key) this.similarWordArr = []
      }
    },

    // 点击相似词：播放发音 + 浮动展示（不修改 store 中的 word）
    searchFromTheSimilarity(word) {
      if (!word) return
      this.playWord(word)
      this.clearFloating()
      this.fetchFloatingInfo(word)
    },

    // 查询单词信息并浮动展示
    async fetchFloatingInfo(word) {
      try {
        const res = await request.get('/searchforword/wordinfo', { params: { word } })
        if (res.code === 200) {
          const info = res.wordInfo || {}
          const meaning = normalizeNewlines(info.meaning || '') || '暂无释义'
          const mainWord = (this.wordInfo && this.wordInfo.word) || ''
          const queryWord = (info.word || word || '').trim()
          this.floatingData = {
            word: queryWord,
            meaning,
            mainWord,
            diffLetters: compareWords(queryWord, mainWord)
          }
          this._floatingTimer = setTimeout(() => this.clearFloating(), 5000)
        }
      } catch (e) {
        this.clearFloating()
      }
    },

    clearFloating() {
      if (this._floatingTimer) {
        clearTimeout(this._floatingTimer)
        this._floatingTimer = null
      }
      this.floatingData = null
    }
  }
}
</script>
